<div class="gallery-controller">
  <div
    [ngClass]="{
      'gallery-controller__container--modal': theme === 'dark',
      'gallery-controller__container': true
    }"
  >
    <button
      class="mr-2 gallery-controller__button"
      *ngFor="let button of controllers; let i = index"
      (click)="select(button, i)"
      [ngClass]="{
        'gallery-controller__button-active': selected === button
      }"
    >
      <lib-icon
          *ngIf="button?.icon"
          class="mr-2"
          [color]="selected === button ? '#FFF' : color"
          [icon]="button.icon"
          size="md"
      ></lib-icon>
      <span>{{ button.label }}</span>
    </button>
  </div>
</div>
